import React, { Component } from 'react';
import Formulario from './ProductoClasificacionForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class ProductoClasificacion extends Component{
    state={
        archivo: null
    }

    componentDidMount = () => {
        const { listarEmpresas } = this.props;
        listarEmpresas();
    }
    
    setArchivo = (archivo) => {
        this.setState({archivo});
    };
    
    productosClasificacion = (data) => {
        const { productosClasificacion } = this.props;
        productosClasificacion( {...data, archivo: null},
        [{ "file": this.state.archivo, "name": 'archivo' },])
    }

    render(){
        const { loader, listarEmpresas } = this.props;
    
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {this.productosClasificacion}
                    listarEmpresas = {listarEmpresas}
                    setArchivo={this.setArchivo} 
                />
            </LoadMask>
        );
    }
}

export default ProductoClasificacion;

